module.exports = __webpack_public_path__ + "media/img/why/venue-e0ccdcce6df8e54c9a8c650c52ecd289.png";